import React, { ReactNode } from "react";

import { Box, SxProps, Theme } from "@mui/material";

export interface PageContainerProps {
  children?: ReactNode;
  maxWidth?: string;
  sx?: SxProps<Theme>;
}

const PageContainer = (props: PageContainerProps) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: props.maxWidth,
      backgroundColor: "background.default",
      p: [2, 3],
      ...props.sx
    }}
  >
    {props.children}
  </Box>
);

export default PageContainer;
